/* eslint-disable no-console */
/**
 * localStorage、sessionStorage工具方法
 */
import { isEmpty } from '@qsxy/element-plus-react';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

const LS = {
	get(key: string): string {
		const val: string = localStorage.getItem(key) || '';
		try {
			const expired: number = Number(localStorage.getItem(key + '__expires__')) || new Date().getTime() + 1;
			const now = new Date().getTime();
			if (now >= expired) {
				LS.rm(key);
				console.warn('存储超时');
				return '';
			}
		} catch (e) {
			console.error(e);
		}
		return val;
	},
	//超时时间 expired 秒( 24*60*60 为一天 )
	set(key: string, value: any, lasted?: boolean, expired?: number) {
		lasted = lasted ?? false;
		expired = expired ?? 24 * 60 * 60;
		try {
			let val = '';
			if (isString(value)) {
				val = value;
			} else {
				val = JSON.stringify(value);
			}
			localStorage.setItem(key, val);
			if (lasted === true) {
				localStorage.setItem(key + '__expires__', String(new Date().getTime() + 1000 * expired));
			}
		} catch (e) {
			if (isQuotaExceeded(e)) {
				console.error('Error: 本地存储超过限制');
				LS.clear();
			} else {
				console.error('Error:isObject 保存到本地存储失败');
			}
		}
	},
	// 移除指定key
	rm: function (key: string) {
		localStorage.removeItem(key);
		localStorage.removeItem(key + '__expires__');
	},
	// 清理
	clear: function () {
		localStorage.clear();
	},
};
const SS = {
	get: function (key: string) {
		if (isEmpty(key)) {
			return '';
		}
		return sessionStorage.getItem(key) ?? '';
	},
	set: function (key: string, value: any) {
		try {
			let val;
			if (isObject(value)) {
				val = JSON.stringify(value);
			} else {
				val = value;
			}
			sessionStorage.setItem(key, val);
		} catch (e) {
			if (isQuotaExceeded(e)) {
				console.error('Error: 本地存储超过限制');
				SS.clear();
			} else {
				console.error('Error: 保存到本地存储失败');
			}
		}
	},
	rm: function (key: string) {
		if (!isEmpty(key)) {
			sessionStorage.removeItem(key);
		}
	},
	clear: function () {
		sessionStorage.clear();
	},
};

function isQuotaExceeded(e: any) {
	let quotaExceeded = false;
	if (e) {
		if (e.code) {
			switch (e.code) {
				case 22:
					quotaExceeded = true;
					break;
				case 1014: // Firefox
					if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
						quotaExceeded = true;
					}
					break;
			}
		} else if (e.number === -2147024882) {
			// IE8
			quotaExceeded = true;
		}
	}
	return quotaExceeded;
}

export { LS, SS, isQuotaExceeded };
